import React, { useEffect, useState } from 'react';
import AppCard from '../AppCard';
import AppTooltip from '../AppTooltip';
import { useDispatch } from 'react-redux';
import { grey } from '@mui/material/colors';
import * as Icons from '@mui/icons-material'
import { alpha } from '@mui/material/styles';
import Button from 'shared/components/Button';
import { SwapHoriz } from '@mui/icons-material';
import { Grid, IconButton, Stack, Typography } from '@mui/material';
import { DialogInformation } from 'shared/components/Dialog';
import { Colors, Fonts, SPACING } from 'shared/constants/AppEnums';
import { useAuthUser, useRoleUser } from '@crema/utility/AuthHooks';
import { updateRoleUser } from '@crema/services/apis/profile';
import { FETCH_ERROR, FETCH_START, FETCH_SUCCESS } from 'shared/constants/ActionTypes';

const optionsRole = {
    'SIPEG_PEGAWAI': {
        id: 'SIPEG_PEGAWAI',
        label: 'Pegawai',
        icon: 'PersonOutlineOutlined'
    },
    'SIPEG_OPERATOR': {
        id: 'SIPEG_OPERATOR',
        label: 'Operator',
        icon: 'PersonPinOutlined'
    },
    'SIPEG_ADMINISTRATOR': {
        id: 'SIPEG_ADMINISTRATOR',
        label: 'Administrator',
        icon: 'SupervisorAccountOutlined'
    },
    'SIPEG_VIEWER': {
        id: 'SIPEG_VIEWER',
        label: 'Viewer',
        icon: 'GroupsOutlined'
    },
    'SIPEG_OPERATOR_ESELON_1': {
        id: 'SIPEG_OPERATOR_ESELON_1',
        label: 'Operator Eselon 1',
        icon: 'Diversity3'
    },
    'SIPEG_ADMIN_360': {
        id: 'SIPEG_ADMIN_360',
        label: 'Admin Penilaian 360',
        icon: 'SupervisorAccountOutlined'
    },
    'SIPEG_OPERATOR_360': {
        id: 'SIPEG_OPERATOR_360',
        label: 'Operator Penilaian 360',
        icon: 'SupervisorAccountOutlined'
    },
    'SIPEG_OPERATOR_ESELON_1_360': {
        id: 'SIPEG_OPERATOR_ESELON_1_360',
        label: 'Operator Eselon 1 Penilaian 360',
        icon: 'SupervisorAccountOutlined',
    }
}

const AppRole = () => {
    const dispatch = useDispatch()
    const { user } = useAuthUser()
    const { currentRole, setRole } = useRoleUser()

    const [activeRole, setActiveRole] = useState(null)
    const [toggleRole, setToggleRole] = useState(false)

    const changeRoleActive = () => {
        if (activeRole !== null) {
            dispatch({ type: FETCH_START })
            updateRoleUser(user?.nip, activeRole)
                .then((res) => {
                    if (res.success) {
                        dispatch({ type: FETCH_SUCCESS })
                        setRole(user?.nip, activeRole)
                        setTimeout(() => setToggleRole(false), 700)
                    }
                })
                .catch((error) => {
                    console.error(error)
                    dispatch({ type: FETCH_ERROR, payload: 'Gagal mengganti role. Mohon coba kembali.' })
                })
        }
    }

    useEffect(() => {
        const filteredRole = user?.role
        setActiveRole(filteredRole)
    }, [user])

    return (
        <Stack direction={'row'} alignItems={'center'} gap={4}>
            <Stack direction={'row'} alignItems={'center'} gap={2}>
                <Typography>Login sebagai:</Typography>
                <Typography fontWeight={'bold'}>{currentRole?.label}</Typography>
            </Stack>

            {user?.groups.length > 1 &&
                <AppTooltip title='Role' placement={'bottom'}>
                    <IconButton
                        className='icon-btn'
                        sx={{
                            borderRadius: '50%',
                            width: 40,
                            height: 40,
                            color: Colors.primary,
                            backgroundColor: alpha(Colors.primary, 0.1),
                            border: 1,
                            borderColor: 'transparent',
                            '&:hover, &:focus': {
                                color: Colors.primary,
                                backgroundColor: alpha(Colors.primary, 0.2),
                                borderColor: (theme) =>
                                    alpha(theme.palette.text.secondary, 0.25),
                            },
                        }}
                        onClick={() => setToggleRole(true)}
                        size='large'
                    >
                        <SwapHoriz />
                    </IconButton>
                </AppTooltip>
            }

            <DialogInformation
                open={toggleRole}
                title={'Ganti Akses Role'}
                handleClose={() => setToggleRole(false)}
                size='sm'
            >
                <Stack spacing={SPACING}>
                    <Stack direction='row' spacing={SPACING} alignItems={'center'} justifyContent={'center'}>
                        <Grid container rowSpacing={2} columnSpacing={2}>
                            {
                                user?.groups.map((item, index) => {
                                    const role = optionsRole[item]
                                    const IconComponent = Icons[role.icon]
                                    const active = role?.id === activeRole
                                    return (
                                        <Grid item key={index} sm={12} md={3}>
                                            <AppCard
                                                key={index}
                                                contentStyle={{ padding: SPACING }}
                                                sxStyle={{
                                                    '&:hover': {
                                                        backgroundColor: alpha(Colors.primary, 0.09),
                                                        borderColor: Colors.primary
                                                    },
                                                    cursor: 'pointer',
                                                    border: active ? 3 : 1,
                                                    borderColor: active ? Colors.primary : grey[400],
                                                    height: 1,
                                                    width: 1,
                                                    transition: '0.3s all ease-in-out'
                                                }}
                                                onClick={() => setActiveRole(role.id)}
                                            >
                                                <Stack height={1} alignItems={'center'} justifyContent={'center'} spacing={SPACING / 2}>
                                                    <IconComponent sx={{ fontSize: 50, color: active ? Colors.primary : grey[600] }} />
                                                    <Typography variant='h3' textAlign={'center'} fontWeight={active ? Fonts.SEMI_BOLD : Fonts.REGULAR} color={active ? Colors.primary : grey[600]}>{role.label}</Typography>
                                                </Stack>
                                            </AppCard>
                                        </Grid>
                                    )
                                })
                            }
                        </Grid>
                    </Stack>

                    <Stack direction={'row'} spacing={SPACING / 2} alignItems={'center'} justifyContent={'end'}>
                        <Button
                            type='primary'
                            label='Simpan'
                            variant='contained'
                            onClick={changeRoleActive}
                        />
                        <Button
                            type='danger'
                            label='Batal'
                            variant='contained'
                            onClick={() => setToggleRole(false)}
                        />
                    </Stack>
                </Stack>
            </DialogInformation>

        </Stack>
    );
};

export default AppRole;